/* eslint-disable sonarjs/no-all-duplicated-branches */
/* eslint-disable react/prop-types */
/* eslint-disable no-debugger */
/* eslint-disable react/jsx-curly-newline */
/* eslint-disable react/jsx-sort-default-props */
/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable arrow-body-style */
import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import ReactTooltip from "react-tooltip";
import {
  CardContainer,
  CardHeader,
  CampaignName,
  StatusBadge,
  StatusIcon,
  StatusText,
  TransactionStatusBadge,
  TransactionStatusIcon,
  TransactionStatusText,
  ContentInside,
  DateInfo,
  PaymentOption,
  OptionHeader,
  OptionLeft,
  OptionTitle,
  OptionLabel,
  OptionDescription,
  OptionRight,
  RadioButton,
  AmountRow,
  AmountValue,
  DownloadRow,
  DownloadButton,
  DownloadIcon,
  DownloadDescription,
  PayButton,
  ChevronIcon,
  InfoTooltip,
  EmptyStateContainer,
  EmptyStateTitle,
  EmptyStateMessage,
  PartialPaymentContainer,
  PartialPaymentTitle,
  PartialPaymentMessage,
  FinalizedPaymentContainer,
  FinalizedPaymentTitle,
  FinalizedPaymentMessage,
  GuaranteeContainer,
  GuaranteeTitleRow,
  GuaranteeTitle,
  GuaranteeMessage,
  GuaranteeMessageBold,
  TimelineContainer,
  TimelineTrack,
  TimelineMarker,
  TimelineDayLabel,
  TimelineMessage,
  TimelineMessageText,
  TooltipContainer,
  AlertContainer,
  AlertText,
  AlertInfoIcon,
  InputFieldWithError,
  WarningIcon,
  PaymentPlanBar,
  PaymentPlanLabel,
  PaymentPlanDownloadButton
} from "../styles";

import IssuerPaymentModel from "../../../lib/models/issuerPayment.model";

/**
 * PaymentCard - Tarjeta de pago responsive
 *
 * @param {Object} props
 * @param {Object} props.campaign - Información de la campaña
 * @param {Object} props.issuerPayment - Información del pago (null si no hay pago)
 * @param {boolean} props.isOverdue - Si el pago está en mora
 * @param {number} props.overdueTotal - Monto total de mora
 * @param {string} props.dateExpiration - Fecha de vencimiento
 * @param {string} props.transactionStatus - Estado de la transacción (null, 'pending', 'approved', 'rejected')
 * @param {string} props.transactionStatusLabel - Etiqueta del estado de transacción
 * @param {boolean} props.isEmpty - Si no hay pagos pendientes
 * @param {boolean} props.isPartialPayment - Si es un pago parcial procesándose
 * @param {number} props.minimumLatePaymentAmount - Monto mínimo de abono para pagos en mora (desde parámetros del sistema)
 * @param {Function} props.onPay - Callback al hacer clic en pagar
 * @param {Function} props.onDownloadExcel - Callback para descargar Excel
 */
const PaymentCard = ({
  campaign,
  issuerPayment,
  isOverdue,
  overdueTotal,
  netAmount,
  dateExpiration,
  businessDaysToPay,
  transactionStatus,
  transactionStatusLabel,
  isEmpty,
  isPartialPayment,
  isFinalizedPaymentCampaign,
  isGuaranteeInExecution,
  isGuaranteeExecuted,
  guaranteeExecutedMessage,
  minimumLatePaymentAmount,
  onPay,
  onDownloadExcel,
  onDownloadAmortization,
  collectionCommission,
  fngCommission,
  overdueInterest,
  overdueInterestRetention,
  collectionRate,
  isMinOverdueInterestPayValidationEnabled
}) => {
  const [selectedOption, setSelectedOption] = useState("total");
  const [customAmount, setCustomAmount] = useState("");
  const [displayAmount, setDisplayAmount] = useState("");
  const [isCustomInputFocused, setIsCustomInputFocused] = useState(false);
  const hasUserModifiedRef = useRef(false);

  /**
   * useEffect para precarga automática de monto pendiente
   * Solo precarga cuando:
   * - Hay una transacción pending
   * - La transacción tiene net_amount > 0
   * - El pago está en mora
   * - El usuario NO ha modificado manualmente el valor
   * - El tipo de transacción es "partial_overdue_payment"
   */
  useEffect(() => {
    if (
      issuerPayment &&
      issuerPayment.issuer_payment_state_id ===
        IssuerPaymentModel.stateId.POR_CONFIRMAR &&
      issuerPayment?.transaction?.net_amount > 0 &&
      isOverdue &&
      issuerPayment?.transaction?.transaction_type ===
        IssuerPaymentModel.transactionType.PAGO_PARCIAL_MORA &&
      !hasUserModifiedRef.current
    ) {
      const roundedAmount = Math.round(issuerPayment.transaction.net_amount);
      setSelectedOption("custom");
      setCustomAmount(roundedAmount.toString());
      setDisplayAmount(formatNumberWithDots(roundedAmount));
    }
  }, [issuerPayment?.transaction, isOverdue]);

  /**
   * Formatea número con separadores de miles (punto)
   * Ej: 1000000 -> "1.000.000"
   */
  const formatNumberWithDots = (value) => {
    if (value === 0 || value === "0") {
      return "0";
    }
    if (value == null || value === "") {
      return "";
    }
    const n = Number(String(value).replace(/[^0-9]/g, ""));
    if (Number.isNaN(n)) {
      return "";
    }
    return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  };

  /**
   * Maneja el cambio en el input de monto personalizado
   * Aplica formato de separadores de miles automáticamente
   */
  const handleCustomAmountChange = (e) => {
    const inputValue = e.target.value;
    let numericValue = inputValue.replace(/[^\d]/g, "");
    numericValue = numericValue.slice(0, 12);
    numericValue = numericValue.replace(/^0+(?=\d)/, "");

    if (numericValue === "") {
      setCustomAmount("");
      setDisplayAmount("");
      hasUserModifiedRef.current = false;
      return;
    }

    setCustomAmount(numericValue);
    setDisplayAmount(formatNumberWithDots(numericValue));
    hasUserModifiedRef.current = true;
  };

  const handleOptionSelect = (option) => {
    if (option === "custom" && !isOverdue) {
      return;
    }

    if (option === "total" && selectedOption === "custom") {
      setCustomAmount("");
      setDisplayAmount("");
    }
    setSelectedOption(option);
  };

  const handlePay = () => {
    const amount =
      selectedOption === "total"
        ? isOverdue
          ? overdueTotal
          : netAmount
        : parseFloat(customAmount);

    onPay({
      campaignId: campaign.campaign_id,
      issuerPayment,
      isOverdue,
      amount,
      paymentType: selectedOption
    });
  };

  /**
   * Retorna objeto con estado de validación y mensaje de error
   */
  const validateCustomAmount = () => {
    if (!customAmount || customAmount === "") {
      return { isValid: false, error: "empty", message: null };
    }

    // customAmount es string sólo con dígitos (normalizado en el handler)
    const amount = parseFloat(customAmount || "0");

    if (Number.isNaN(amount) || amount <= 0) {
      return {
        isValid: false,
        error: "invalid",
        message: "El monto debe ser mayor a cero."
      };
    }

    // longitud máxima
    if (customAmount.length > 12) {
      return {
        isValid: false,
        error: "length",
        message: "El monto no puede tener más de 12 dígitos."
      };
    }

    if (isOverdue && amount < minimumLatePaymentAmount) {
      return {
        isValid: false,
        error: "minimum",
        message: `El monto mínimo de abono es ${formatCurrency(
          minimumLatePaymentAmount
        )}`
      };
    }

    const totalAmount = isOverdue ? overdueTotal : issuerPayment.total;
    const collection = isOverdue ? collectionCommission : 0;
    const maxAllowed = totalAmount - collection;
    if (amount >= maxAllowed) {
      return {
        isValid: false,
        error: "maximum",
        message: `El abono no puede ser igual o superior al total de mora menos cobranza. Monto máximo: ${formatCurrency(
          parseInt(maxAllowed)
        )}.`
      };
    }


 if (isMinOverdueInterestPayValidationEnabled) {
  const totalFng = fngCommission ?? 0;
  const totalInterestOverdue = overdueInterest ?? 0;
  const totalInterestRetention = overdueInterestRetention ?? 0;
  const collectionRateDecimal = (collectionRate ?? 0) / 100;

  const minimumBaseRule =
    totalFng +
    totalInterestOverdue -
    totalInterestRetention;

  // Total teórico (sin redondear)
  const theoreticalMinimumAmount =
    collectionRateDecimal > 0
      ? minimumBaseRule / (1 - collectionRateDecimal * 1.19)
      : minimumBaseRule;

  // Cobranza redondeada al peso
  const collectionValue = Math.round(
    theoreticalMinimumAmount * collectionRateDecimal
  );

  // IVA redondeado al peso
  const collectionIva = Math.round(collectionValue * 0.19);

  // Total cobranza (entero)
  const totalCollection = collectionValue + collectionIva;

  // Mínimo permitido definitivo
  const minimumAmount = minimumBaseRule + totalCollection;



  if (amount < minimumAmount) {
    return {
      isValid: false,
      error: "minimum",
      message: `El abono debe ser igual o superior a ${formatCurrency(minimumAmount)} correspondiente al total de intereses de mora + comisión de cobranza + comisión de garantía (si aplica).`
    };
  }
}

    return { isValid: true, error: null };
  };

  const isPayButtonDisabled = () => {
    // Deshabilitar si hay una transacción pendiente o aprobada
    // Nota: "rejected" permite reintentar el pago
    if (transactionStatus === "pending" || transactionStatus === "approved") {
      return true;
    }

    if (selectedOption === "custom") {
      const validation = validateCustomAmount();
      return !validation.isValid;
    }
    return false;
  };

  // Las opciones se deshabilitan solo en pending y approved
  // En rejected el usuario puede intentar pagar nuevamente
  const areOptionsDisabled =
    transactionStatus === "pending" || transactionStatus === "approved";

  // La opción "Otro monto" solo está disponible para pagos en mora
  const isCustomOptionDisabled = !isOverdue || areOptionsDisabled;

  // El input solo se habilita cuando la opción "Otro monto" está seleccionada
  const isCustomInputDisabled =
    isCustomOptionDisabled || selectedOption !== "custom";

  // El símbolo $ solo se muestra cuando la opción "Otro monto" está seleccionada
  const showCurrency = selectedOption === "custom";

  const formatCurrency = (value) => {
    return new Intl.NumberFormat("es-CO", {
      style: "currency",
      currency: "COP",
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    }).format(value);
  };

  const formatDate = (dateString) => {
    // Manejar formato con espacio o con T, y extraer solo la fecha
    const datePart = dateString.split("T")[0].split(" ")[0];
    const [year, month, day] = datePart.split("-").map(Number);

    const monthNames = [
      "enero",
      "febrero",
      "marzo",
      "abril",
      "mayo",
      "junio",
      "julio",
      "agosto",
      "septiembre",
      "octubre",
      "noviembre",
      "diciembre"
    ];

    const monthName = monthNames[month - 1];
    return `${monthName} ${day} de ${year}`;
  };

  /**
   * Detecta si el usuario está en período de gracia
   * Período de gracia: fecha de vencimiento original cayó en día no hábil,
   * hoy es después del vencimiento original pero antes/igual al día hábil ajustado
   */
  const isInGracePeriod = () => {
    if (!issuerPayment?.payment_expiration_date || !dateExpiration) {
      return false;
    }

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const originalDatePart = issuerPayment.payment_expiration_date
      .split("T")[0]
      .split(" ")[0];
    const [origYear, origMonth, origDay] = originalDatePart
      .split("-")
      .map(Number);
    const originalExpirationDate = new Date(origYear, origMonth - 1, origDay);
    originalExpirationDate.setHours(0, 0, 0, 0);

    const adjustedDatePart = dateExpiration.split("T")[0].split(" ")[0];
    const [adjYear, adjMonth, adjDay] = adjustedDatePart.split("-").map(Number);
    const adjustedExpirationDate = new Date(adjYear, adjMonth - 1, adjDay);
    adjustedExpirationDate.setHours(0, 0, 0, 0);

    // Está en gracia si:
    // 1. Hoy es el día de vencimiento original o después
    // 2. Hoy es antes o igual a la fecha ajustada
    // 3. Las fechas son diferentes (hubo ajuste)
    return (
      today >= originalExpirationDate &&
      today <= adjustedExpirationDate &&
      originalExpirationDate.getTime() !== adjustedExpirationDate.getTime()
    );
  };

  /**
   * Calcula los días calendario restantes hasta la fecha de vencimiento
   * Incluye hoy como día disponible para pagar (+1)
   */
  const calculateCalendarDaysRemaining = () => {
    if (!dateExpiration) {
      return null;
    }

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const datePart = dateExpiration.split("T")[0].split(" ")[0];
    const [year, month, day] = datePart.split("-").map(Number);
    const expirationDate = new Date(year, month - 1, day);
    expirationDate.setHours(0, 0, 0, 0);

    const diffTime = expirationDate - today;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    // +1 porque hoy también cuenta como día disponible para pagar
    return diffDays + 1;
  };

  /**
   * Calcula la posición del marcador en el timeline según días restantes
   * Para días > 10, el marcador se mueve muy poco (imperceptible) antes del día 10
   */
  const calculateTimelinePosition = (days) => {
    const positions = {
      0: "94%",
      1: "86%",
      2: "78%",
      3: "70%",
      4: "58%",
      5: "46%",
      6: "38%",
      7: "32%",
      8: "25%",
      9: "15%",
      10: "5%"
    };

    if (positions[days]) {
      return {
        position: positions[days],
        percentage: parseFloat(positions[days])
      };
    }

    // Más de 10 días: se mueve muy poco en el primer tramo (0% a 5%)
    // Día 11 = 4%, día 12 = 3%, días 13-15 = 2% (para evitar desborde)
    if (days > 10) {
      const extraDays = days - 10;
      const percentage = Math.max(2, 5 - extraDays * 1);
      return { position: `${percentage}%`, percentage };
    }

    return { position: "5%", percentage: 5 };
  };

  /**
   * Renderiza el timeline con los días calendario restantes
   * Usa calendarDaysRemaining para mostrar días hasta el vencimiento
   * businessDaysToPay solo se usa para detectar si el vencimiento cae en día no hábil
   */
  const renderTimeline = () => {
    const calendarDaysRemaining = calculateCalendarDaysRemaining();
    const inGracePeriod = isInGracePeriod();

    if (
      calendarDaysRemaining === null ||
      isOverdue ||
      calendarDaysRemaining > 16 ||
      (calendarDaysRemaining < 1 && !inGracePeriod)
    ) {
      return null;
    }

    let daysForPosition;
    let position;

    if (inGracePeriod) {
      daysForPosition = 0;
      position = "94%";
    } else {
      daysForPosition = calendarDaysRemaining - 1;
      const positionData = calculateTimelinePosition(daysForPosition);
      position = positionData.position;
    }

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const adjustedDatePart = dateExpiration.split("T")[0].split(" ")[0];
    const [adjYear, adjMonth, adjDay] = adjustedDatePart.split("-").map(Number);
    const adjustedExpirationDate = new Date(adjYear, adjMonth - 1, adjDay);
    adjustedExpirationDate.setHours(0, 0, 0, 0);
    const isTodayTheAdjustedExpirationDay =
      today.getTime() === adjustedExpirationDate.getTime();

    const expirationIsNonBusinessDay =
      (calendarDaysRemaining === 1 && businessDaysToPay > 0) || inGracePeriod;

    let message = "";
    let messageAlign = "center";

    if (inGracePeriod && isTodayTheAdjustedExpirationDay) {
      message = "Es tu último día \n de pago";
      messageAlign = "right";
    } else if (expirationIsNonBusinessDay) {
      message = "Podrás hacer tu pago \n el próximo día hábil";
      messageAlign = "right";
    } else if (calendarDaysRemaining === 1) {
      message = "Es tu último día \n de pago";
      messageAlign = "right";
    } else if (calendarDaysRemaining === 2) {
      message = "Falta 1 día \n para el pago";
      messageAlign = "right";
    } else if (calendarDaysRemaining >= 3 && calendarDaysRemaining <= 4) {
      message = `Te quedan ${calendarDaysRemaining - 1} \n días para pagar`;
      messageAlign = "right";
    } else if (calendarDaysRemaining >= 9 && calendarDaysRemaining <= 16) {
      message = `Te quedan ${calendarDaysRemaining - 1} \n días para pagar`;
      messageAlign = "left";
    } else if (calendarDaysRemaining < 1) {
      message = `Te quedan ${Math.max(
        0,
        calendarDaysRemaining - 1
      )} \n días para pagar`;
      messageAlign = "right";
    } else {
      message = `Te quedan ${calendarDaysRemaining - 1} \n días para pagar`;
    }

    const trackWidth = position;

    return (
      <TimelineContainer>
        <TimelineDayLabel position="5%">día 10</TimelineDayLabel>
        <TimelineDayLabel position="5%" isPipe={true} top="23px">
          |
        </TimelineDayLabel>
        <TimelineDayLabel position="15%">día 9</TimelineDayLabel>
        <TimelineDayLabel position="15%" isPipe={true} top="23px">
          |
        </TimelineDayLabel>
        <TimelineDayLabel position="25%">día 8</TimelineDayLabel>
        <TimelineDayLabel position="25%" isPipe={true} top="23px">
          |
        </TimelineDayLabel>
        <TimelineDayLabel position="70%">día 3</TimelineDayLabel>
        <TimelineDayLabel position="70%" isPipe={true} top="23px">
          |
        </TimelineDayLabel>
        <TimelineDayLabel
          position="93%"
          isHighlighted={calendarDaysRemaining === 1}
        >
          día 0
        </TimelineDayLabel>
        <TimelineDayLabel position="93%" isPipe={true} top="23px">
          |
        </TimelineDayLabel>

        <TimelineTrack
          width="calc(100% + 48px)"
          left="-24px"
          isNearDue={calendarDaysRemaining <= 4}
        />

        <TimelineTrack width={trackWidth} left="-2px" isProgress={true} />

        <TimelineMarker
          position={position}
          isOverdue={calendarDaysRemaining <= 4}
        />

        <TimelineMessage
          isOverdue={calendarDaysRemaining <= 4}
          align={messageAlign}
        >
          <TimelineMessageText isOverdue={calendarDaysRemaining <= 4}>
            {message}
          </TimelineMessageText>
        </TimelineMessage>
      </TimelineContainer>
    );
  };

  // Barra de plan de pagos reutilizable
  const renderPaymentPlanBar = () => (
    <PaymentPlanBar>
      <PaymentPlanLabel>Conoce el plan de pagos de tu campaña</PaymentPlanLabel>
      <PaymentPlanDownloadButton
        onClick={() =>
          onDownloadAmortization({
            campaignId: campaign.campaign_id
          })
        }
      >
        <span>Descargar</span>
        <DownloadIcon />
      </PaymentPlanDownloadButton>
    </PaymentPlanBar>
  );

  // Si la garantía está en proceso de ejecución (state_id=6) — RN02: prima el estado de la tabla padre
  if (isGuaranteeInExecution) {
    return (
      <CardContainer>
        <div>
          <CardHeader>
            <CampaignName>
              <span className="regular">Campaña </span>
              <span className="bold">{campaign.name}</span>
            </CampaignName>
          </CardHeader>
          {renderPaymentPlanBar()}
        </div>
        <GuaranteeContainer>
          <GuaranteeTitleRow>
            <WarningIcon isPartialOverdue={true} />
            <GuaranteeTitle>Garantía en ejecución</GuaranteeTitle>
          </GuaranteeTitleRow>
          <GuaranteeMessage>
            <GuaranteeMessageBold>Estimado empresario:</GuaranteeMessageBold>
            {" la garantía de la campaña se está ejecutando"}
          </GuaranteeMessage>
        </GuaranteeContainer>
      </CardContainer>
    );
  }

  // Si la garantía ya fue ejecutada (state_id=4) — RN02: prima el estado de la tabla padre
  if (isGuaranteeExecuted) {
    return (
      <CardContainer>
        <div>
          <CardHeader>
            <CampaignName>
              <span className="regular">Campaña </span>
              <span className="bold">{campaign.name}</span>
            </CampaignName>
          </CardHeader>
          {renderPaymentPlanBar()}
        </div>
        <GuaranteeContainer>
          <GuaranteeTitleRow>
            <WarningIcon isPartialOverdue={true} />
            <GuaranteeTitle>Garantía ejecutada</GuaranteeTitle>
          </GuaranteeTitleRow>
          <GuaranteeMessage>
            {guaranteeExecutedMessage
              ? guaranteeExecutedMessage
                  .split(/<br\s*\/?>|\n/i)
                  .map((line, idx, arr) => (
                    <React.Fragment key={idx}>
                      {line}
                      {idx < arr.length - 1 && <br />}
                    </React.Fragment>
                  ))
              : null}
          </GuaranteeMessage>
        </GuaranteeContainer>
      </CardContainer>
    );
  }

  // Si la campaña de pagos ya finalizó, mostrar visual informativa
  if (isFinalizedPaymentCampaign) {
    return (
      <CardContainer>
        <div>
          <CardHeader>
            <CampaignName>
              <span className="regular">Campaña </span>
              <span className="bold">{campaign.name}</span>
            </CampaignName>
          </CardHeader>
          {renderPaymentPlanBar()}
        </div>

        <FinalizedPaymentContainer>
          <FinalizedPaymentTitle>
            Tus pagos han finalizado, para conocer el detalle consulta el
            Historial de pagos
          </FinalizedPaymentTitle>
          <FinalizedPaymentMessage>
            ☺️ ¡En a2censo junto a ti, estamos haciendo historia! 🎉
          </FinalizedPaymentMessage>
        </FinalizedPaymentContainer>
      </CardContainer>
    );
  }

  // Si es un pago parcial en proceso, mostrar mensaje especial
  if (isPartialPayment) {
    return (
      <CardContainer>
        <div>
          <CardHeader>
            <CampaignName>
              <span className="regular">Campaña </span>
              <span className="bold">{campaign.name}</span>
            </CampaignName>
          </CardHeader>
          {renderPaymentPlanBar()}
        </div>

        <PartialPaymentContainer>
          <PartialPaymentTitle>
            <WarningIcon isPartialOverdue={true} />
            Recibimos tu pago parcial de mora
          </PartialPaymentTitle>
          <PartialPaymentMessage numberOne={true}>
            Debes esperar mientras se procesa y actualiza tu saldo en mora.
          </PartialPaymentMessage>
          <PartialPaymentMessage numberTwo={true}>
            Te informaremos pronto el nuevo valor pendiente a pagar.
          </PartialPaymentMessage>
        </PartialPaymentContainer>
      </CardContainer>
    );
  }

  // Si no hay pagos pendientes, mostrar estado vacío
  if (isEmpty || !issuerPayment) {
    return (
      <CardContainer>
        <div>
          <CardHeader>
            <CampaignName>
              <span className="regular">Campaña </span>
              <span className="bold">{campaign.name}</span>
            </CampaignName>
          </CardHeader>
          {renderPaymentPlanBar()}
        </div>

        <EmptyStateContainer>
          <EmptyStateTitle>
            <WarningIcon isPartialOverdue={false} />
            ¡No tienes pagos pendientes!
          </EmptyStateTitle>
          <EmptyStateMessage>
            Te informaremos vía e-mail cuando tu próximo pago esté listo.
          </EmptyStateMessage>
        </EmptyStateContainer>
      </CardContainer>
    );
  }

  return (
    <TooltipContainer>
      <CardContainer>
        {/* Header con nombre de campaña */}
        <div>
          <CardHeader>
            <CampaignName>
              <span className="regular">Campaña </span>
              <span className="bold">{campaign.name}</span>
            </CampaignName>
          </CardHeader>
          {renderPaymentPlanBar()}

          {/* Badge de estado del pago */}
          {!transactionStatus && (
            <StatusBadge isOverdue={isOverdue}>
              <StatusIcon isOverdue={isOverdue} />
              <StatusText isOverdue={isOverdue}>
                <span className="regular">Estado del pago: </span>
                <span className="bold">
                  {isOverdue ? "En mora" : "Pendiente"}
                </span>
              </StatusText>
            </StatusBadge>
          )}

          {/* Badge de estado de transacción*/}
          {transactionStatus && (
            <>
              <TransactionStatusBadge status={transactionStatus}>
                <TransactionStatusIcon status={transactionStatus} />
                <TransactionStatusText>
                  <span className="regular">Estado transacción: </span>
                  <span className="bold">
                    {transactionStatusLabel || "Por confirmar"}
                  </span>
                </TransactionStatusText>
              </TransactionStatusBadge>

              {/* Mensaje especial cuando pago aprobado en mora */}
              {/* {transactionStatus === "approved" && isOverdue && (
                <TransactionStatusBadge status="info">
                  <TransactionStatusText>
                    <span className="regular">
                      Los saldos en mora se están actualizando. Los verás
                      reflejados al día siguiente.
                    </span>
                  </TransactionStatusText>
                </TransactionStatusBadge>
              )} */}

              {/* Mensaje cuando pago es rechazado */}
              {/* {transactionStatus === "rejected" && (
                <TransactionStatusBadge status="info">
                  <TransactionStatusText>
                    <span className="regular">
                      La transacción fue rechazada. Puedes intentar realizar el
                      pago nuevamente.
                    </span>
                  </TransactionStatusText>
                </TransactionStatusBadge>
              )} */}
            </>
          )}
        </div>

        {/* Timeline - Solo para pagos pendientes (no en mora) */}
        {!isOverdue && renderTimeline()}

        {/* Contenido interno */}
        <ContentInside>
          {/* Fecha límite */}
          <DateInfo>
            <span className="regular">
              {isOverdue
                ? "Tu fecha límite de pago fue:"
                : "Fecha límite de pago:"}
            </span>
            <span className="bold">{formatDate(dateExpiration)}</span>
          </DateInfo>

          {/* Opción 1: Pago de cuota / Pago total mora */}
          <PaymentOption
            selected={selectedOption === "total"}
            disabled={areOptionsDisabled}
            onClick={() => !areOptionsDisabled && handleOptionSelect("total")}
          >
            <OptionHeader>
              <OptionLeft>
                {/* Fila 1: Título y Label */}
                <AmountRow>
                  <OptionTitle>
                    <h3>{isOverdue ? "Pago total mora" : "Pago de cuota"}</h3>
                  </OptionTitle>
                  <OptionLabel>Valor a pagar en COP</OptionLabel>
                </AmountRow>

                {/* Fila 2: Descripción y Monto */}
                <AmountRow>
                  <OptionDescription>
                    {isOverdue
                      ? "Corresponde al monto total de mora que adeudas a la fecha."
                      : "Monto que debes pagar según tu plan de financiación."}
                  </OptionDescription>
                  <AmountValue>{formatCurrency(netAmount)}</AmountValue>
                </AmountRow>

                {/* Fila 3: Detalle y Botón de descarga */}
                <DownloadRow>
                  <DownloadDescription>
                    {isOverdue
                      ? "Detalle del pago en mora"
                      : "Detalle del pago de cuota"}
                  </DownloadDescription>
                  <DownloadButton
                    onClick={(e) => {
                      e.stopPropagation();
                      onDownloadExcel({
                        campaignId: campaign.campaign_id,
                        userId: campaign.user_id,
                        userEmail: campaign.user_email,
                        issuerPaymentId: issuerPayment?.id,
                        isOverdue
                      });
                    }}
                  >
                    <span>Descargar</span>
                    <DownloadIcon />
                  </DownloadButton>
                </DownloadRow>
              </OptionLeft>
              <OptionRight
                mobileVerticalAlign="center"
                mobileMarginTop="15px"
                verticalAlign="center"
              >
                <RadioButton checked={selectedOption === "total"} />
              </OptionRight>
            </OptionHeader>
          </PaymentOption>

          {/* Opción 2: Otro monto */}
          <PaymentOption
            selected={selectedOption === "custom"}
            disabled={isCustomOptionDisabled}
            onClick={() =>
              !isCustomOptionDisabled && handleOptionSelect("custom")
            }
          >
            <OptionHeader>
              <OptionLeft>
                {/* Fila 1: Título y Label */}
                <AmountRow>
                  <OptionTitle>
                    <h3>Otro monto</h3>
                    <InfoTooltip
                      data-tip={true}
                      data-for="otro-monto-tooltip"
                    />
                    <ReactTooltip
                      id="otro-monto-tooltip"
                      type="dark"
                      effect="solid"
                      place="top"
                      className="payment-tooltip"
                    >
                      <span>
                        {isOverdue
                          ? "Recuerda: solo puedes hacer un abono a la mora al día. Si el pago es exitoso, los saldos de mora actualizados estarán disponibles al día siguiente."
                          : "Recuerda: solo puedes hacer un abono a la mora al día. Si el pago es exitoso, los saldos de mora actualizados estarán disponibles al día siguiente."}
                      </span>
                    </ReactTooltip>
                  </OptionTitle>
                  <OptionLabel>Valor a pagar en COP</OptionLabel>
                </AmountRow>

                {/* Fila 2: Descripción e Input */}
                <AmountRow>
                  <OptionDescription>
                    {isOverdue
                      ? "Acá podrás hacer abonos a la mora."
                      : "Acá podrás hacer abonos a la mora."}
                  </OptionDescription>
                  <InputFieldWithError
                    isError={
                      customAmount &&
                      selectedOption === "custom" &&
                      !validateCustomAmount().isValid
                    }
                    showCurrency={showCurrency}
                  >
                    <span className="currency">$</span>
                    <input
                      type="text"
                      placeholder={showCurrency ? "0" : ""}
                      value={displayAmount}
                      disabled={isCustomInputDisabled}
                      onChange={handleCustomAmountChange}
                      onClick={(e) => e.stopPropagation()}
                      aria-label="Monto personalizado"
                      onFocus={() => setIsCustomInputFocused(true)}
                      onBlur={() => setIsCustomInputFocused(false)}
                    />
                  </InputFieldWithError>
                </AmountRow>

                {customAmount &&
                  selectedOption === "custom" &&
                  !validateCustomAmount().isValid && (
                    <AlertContainer>
                      <AlertText>*Valor no válido</AlertText>
                      <AlertInfoIcon
                        data-tip={true}
                        data-for="validation-tooltip"
                      />
                      <ReactTooltip
                        id="validation-tooltip"
                        type="dark"
                        effect="solid"
                        place="top"
                        className="payment-tooltip"
                      >
                        <span>{validateCustomAmount().message}</span>
                      </ReactTooltip>
                    </AlertContainer>
                  )}
              </OptionLeft>
              <OptionRight
                mobileVerticalAlign="center"
                mobileMarginTop="15px"
                verticalAlign="center"
                marginTop="35px"
              >
                <RadioButton checked={selectedOption === "custom"} />
              </OptionRight>
            </OptionHeader>
          </PaymentOption>

          {/* Botón de pagar */}
          <PayButton disabled={isPayButtonDisabled()} onClick={handlePay}>
            <span>Pagar</span>
            <ChevronIcon>
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.5 15L12.5 10L7.5 5"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </ChevronIcon>
          </PayButton>
        </ContentInside>
      </CardContainer>
    </TooltipContainer>
  );
};

PaymentCard.propTypes = {
  campaign: PropTypes.shape({
    campaign_id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    user_id: PropTypes.number,
    user_email: PropTypes.string
  }).isRequired,
  issuerPayment: PropTypes.shape({
    total: PropTypes.number.isRequired,
    state: PropTypes.string.isRequired,
    payment_expiration_date: PropTypes.string
  }),
  isOverdue: PropTypes.bool,
  overdueTotal: PropTypes.number,
  dateExpiration: PropTypes.string,
  businessDaysToPay: PropTypes.number,
  transactionStatus: PropTypes.oneOf([null, "pending", "approved", "rejected"]),
  transactionStatusLabel: PropTypes.string,
  isEmpty: PropTypes.bool,
  isPartialPayment: PropTypes.bool,
  isFinalizedPaymentCampaign: PropTypes.bool,
  isGuaranteeInExecution: PropTypes.bool,
  isGuaranteeExecuted: PropTypes.bool,
  guaranteeExecutedMessage: PropTypes.string,
  minimumLatePaymentAmount: PropTypes.number,
  onPay: PropTypes.func,
  onDownloadExcel: PropTypes.func,
  onDownloadAmortization: PropTypes.func,
  isMinOverdueInterestPayValidationEnabled: PropTypes.bool
};

PaymentCard.defaultProps = {
  issuerPayment: null,
  isOverdue: false,
  overdueTotal: 0,
  dateExpiration: null,
  businessDaysToPay: null,
  transactionStatus: null,
  transactionStatusLabel: null,
  isEmpty: false,
  isPartialPayment: false,
  isFinalizedPaymentCampaign: false,
  isGuaranteeInExecution: false,
  isGuaranteeExecuted: false,
  guaranteeExecutedMessage:
    "Tras 180 días consecutivos de mora sin regularización de pagos, se ha ejecutado la garantía de la campaña.<br/><br/>En adelante, el proveedor de la garantía se constituye como acreedor por el valor cubierto y realizará las gestiones correspondientes.<br/><br/>Para más información, puedes escribir a: a2censo@bvc.com.co",
  minimumLatePaymentAmount: 50000,
  onPay: () => {},
  onDownloadExcel: () => {},
  onDownloadAmortization: () => {}
};

export default PaymentCard;
